import React, { useEffect, useState } from 'react';
import { CheckCircle2, Star } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  const [viewers, setViewers] = useState(27);
  useEffect(() => {
    const interval = setInterval(() => {
      setViewers(Math.floor(Math.random() * (45 - 15 + 1)) + 15);
    }, 30000);
    return () => clearInterval(interval);
  }, []);
  const bullets = ['Sabé exactamente qué hacer cuando llora', 'Tené rutinas que funcionan de verdad', 'Manejá berrinches sin culpa ni gritos', 'Sentite segura en cada decisión'];
  return <section className="bg-brand-cream pt-12 pb-16 px-6 overflow-hidden" data-id="element-114">
      <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-10 items-center" data-id="element-115">
        {/* Left Column: Copy */}
        <div className="space-y-5" data-id="element-116">
          <div className="inline-block bg-brand-light/20 text-brand-sage font-semibold px-4 py-1.5 rounded-full text-sm" data-id="element-117">
            Sistema Completo de Crianza 0 a 3 años
          </div>

          <h1 className="text-3xl md:text-4xl lg:text-5xl font-serif text-brand-black leading-tight" data-id="element-118">
            Si sentís que estás improvisando todo el tiempo con tu hijo… no sos
            la única.
          </h1>

          <p className="text-lg text-brand-charcoal/80" data-id="element-119">
            Este sistema te da la claridad y estructura que necesitás para dejar
            de dudar y empezar a disfrutar la maternidad.
          </p>

          {/* Precio prominente */}
          <div className="bg-white p-4 rounded-2xl shadow-md border-2 border-brand-sage/20 inline-block w-full sm:w-auto" data-id="element-120">
            <p className="text-brand-charcoal/70 font-medium mb-1" data-id="element-121">
              Valor real:{' '}
              <span className="line-through text-brand-red text-xl" data-id="element-122">
                $138.000
              </span>
            </p>
            <p className="text-4xl font-black text-brand-sage flex items-center gap-3" data-id="element-123">
              Hoy: $19.990
              <span className="text-sm bg-brand-red text-white px-3 py-1 rounded-full font-bold uppercase tracking-wide" data-id="element-124">
                50% OFF
              </span>
            </p>
          </div>

          <ul className="space-y-3" data-id="element-125">
            {bullets.map((bullet, index) => <li key={index} className="flex items-start gap-3" data-id="element-126">
                <CheckCircle2 className="w-6 h-6 text-brand-sage flex-shrink-0 mt-0.5" data-id="element-127" />
                <span className="text-brand-charcoal font-medium" data-id="element-128">
                  {bullet}
                </span>
              </li>)}
          </ul>

          {/* CTA inmediato */}
          <div className="space-y-3 pt-4" data-id="element-129">
            <CTAButton text="QUIERO DEJAR DE IMPROVISAR" data-id="element-130" />

            <div className="flex items-center justify-center sm:justify-start gap-2 mt-2" data-id="element-131">
              <div className="relative flex h-2.5 w-2.5" data-id="element-132">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-500 opacity-75" data-id="element-133"></span>
                <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-green-500" data-id="element-134"></span>
              </div>
              <span className="text-sm font-medium text-brand-charcoal/80" data-id="element-135">
                <strong className="text-brand-black" data-id="element-136">{viewers} personas</strong>{' '}
                están viendo esto ahora
              </span>
            </div>

            <div className="flex items-center gap-3 justify-center sm:justify-start pt-2" data-id="element-137">
              <div className="flex text-brand-gold" data-id="element-138">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-139" />)}
              </div>
              <span className="text-sm font-medium text-brand-charcoal" data-id="element-140">
                + de 1.000 mamás confían en este sistema
              </span>
            </div>
          </div>
        </div>

        {/* Right Column: Real Images */}
        <div className="relative w-full aspect-[4/5] flex items-center justify-center" data-id="element-141">
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] bg-brand-sage/10 rounded-full blur-3xl -z-10" data-id="element-142"></div>

          <img src="https://cdn.magicpatterns.com/uploads/px3Xq7FZWG1G3tE7tj2UoM/MOCKUP_EBOOK_100_ACTIVIDADES.png" alt="100 Actividades y Juegos" className="absolute w-[65%] right-0 top-10 rounded-lg shadow-2xl rotate-6 hover:rotate-0 transition-transform duration-500 z-10" data-id="element-143" />
          <img src="https://cdn.magicpatterns.com/uploads/a1ucxzbmvAv88ReZGGb89a/MOCKUP_EBOOK_PRIMEROS_PASOS.png" alt="Primeros Pasos" className="absolute w-[65%] left-0 bottom-10 rounded-lg shadow-2xl -rotate-6 hover:rotate-0 transition-transform duration-500 z-20" data-id="element-144" />

          <div className="absolute -top-4 -right-4 bg-brand-red text-white font-black py-3 px-5 rounded-full shadow-xl transform rotate-12 z-30 border-4 border-white" data-id="element-145">
            50% OFF
          </div>
        </div>
      </div>
    </section>;
}